<template>
  <div>
    <QrTicketPrinting
      v-for="(ticket, index) in tickets"
      :key="index"
      v-bind="ticket"
      :page-break-after="true"
    />
  </div>
</template>

<script>
import QrTicketPrinting from './QrTicketPrinting.vue'
import { getTicketForPrintApi } from '@/api/reception/reception'

export default {
  components: {
    QrTicketPrinting
  },
  props: {
    invoiceCode: {
      type: String,
      default: null
    },
    typeAPI: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      tickets: null
    }
  },
  mounted() {
    setTimeout(() => {
      this.getPrintData(this.invoiceCode)
    }, 500)
  },
  methods: {
    async getPrintData(code) {
      const params = {
        type: this.typeAPI,
        invoiceCode: code
      }
      await getTicketForPrintApi(params).then(res => {
        this.tickets = res.data.map(item => {
          return {
            ...item,
            print_time: this.$moment(new Date()).format('DD/MM/YY HH:mm:ss')
          }
        })
        setTimeout(() => {
          this.$emit('filled')
        }, 500)
      })
    }
  }
}
</script>
